






























































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { AxiosStatic } from "axios";
import IReservation from '@/interfaces/IReservation';
import IResource from '@/interfaces/IResource';
import StatusBadge from '@/components/StatusBadge.vue';
import ConfirmReservationModal from '@/components/ConfirmReservationModal.vue';

@Component({
	components: {
		StatusBadge,
		ConfirmReservationModal
	},
})
export default class ReservationListWidget extends Vue {

	public reservations: IReservation[] | null = null;
	public isLoading: boolean = false;
	private $http!: AxiosStatic;
	@Prop({
		required: false,
		type: Number
	})
	public resourceId?: number;

	get reservationsNext(): IReservation[] {
		if (this.reservations) {
			return this.reservations.slice(0,4);
		}
		return [];
	}

	get resource(): IResource | null {
		if (this.$store.state.resources && this.resourceId) {
			let filtered = this.$store.state.resources.filter((r: IResource) => r.id == this.resourceId);
			if (filtered.length > 0) {
				return filtered[0];
			}
		} else if (this.$store.state.resources && !this.resourceId) {
			return this.$store.state.resources;
		}
		return null;
	}

	@Watch('resourceId')
	public watchResourceId() {
		this.loadReservations();
	}

	public async mounted(): Promise<void> {
		await this.loadReservations();
		this.$store.dispatch('loadResources', {root: true});
	}

	private async loadReservations(): Promise<void> {
		this.isLoading = true;
		if (this.resourceId) {
			const response = await this.$http.get(`/private/resource/${ this.resourceId }/reservations?order_by=start&state=open`);
			if (response.status !== 200) {
				throw new Error('error loading reservations, no resource found');
			}
			this.reservations = response.data;
		} else {
			const response = await this.$http.get(`/private/reservation?order_by=start&state=open`);
			if (response.status !== 200) {
				throw new Error('error loading reservations');
			}
			this.reservations = response.data;
		}
		this.isLoading = false;
	}
}
